import {observer} from "mobx-react";
import {useServices} from "../../react-hooks/use-services.hook";
import {Magic8BallAnimationComponent} from "../magic-8-ball-animation/magic-8-ball-animation.component";

interface IMagic8BallLayerContainerComponentProps {}

export const Magic8BallLayerContainerComponent: React.FC<IMagic8BallLayerContainerComponentProps> = observer(props => {
    const services = useServices();

    if (!services.magic8ball.showIntent) {
        return null;
    }
    return <Magic8BallAnimationComponent
        showIntent={services.magic8ball.showIntent}
    />
});